/* wwp-card-lb.js v2
   CAPTURE PHASE listener — fires before Dawn's anchor navigation
   Image click → lightbox. Title click → product page.
*/
(function(){
  if(window.wwpCardLb)return; window.wwpCardLb=true;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var cache={};

  /* ── Inject CSS: block anchor over image area, style lightbox ── */
  var S=document.createElement('style');
  S.textContent=[
    /* The full-unstyled-link anchor wraps card__inner — disable pointer events on it */
    /* so only our button inside it receives clicks on the image area */
    '.card__inner > a.full-unstyled-link { pointer-events: none !important; }',
    /* Our button fills the image area and catches clicks */
    '.wwp-img-btn { pointer-events: auto !important; position:absolute;inset:0;width:100%;height:100%;background:none;border:none;padding:0;cursor:zoom-in;display:block;z-index:5;}',
    '.wwp-img-btn .media,.wwp-img-btn .media--transparent,.wwp-img-btn .media--hover-effect{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;}',
    /* Lightbox */
    '#wwp-clb{display:none;position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.94);flex-direction:column;align-items:center;justify-content:center;}',
    '#wwp-clb.is-open{display:flex;}',
    '#wwp-clb-close{position:fixed;top:14px;right:16px;background:rgba(255,255,255,.15);border:none;color:#fff;font-size:24px;width:40px;height:40px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;backdrop-filter:blur(6px);}',
    '#wwp-clb-wrap{position:relative;width:min(520px,94vw);padding:0 44px;display:flex;align-items:center;justify-content:center;}',
    '#wwp-clb-img{width:100%;max-height:72vh;object-fit:contain;border-radius:12px;display:block;transition:opacity .18s;}',
    '#wwp-clb-img.is-loading{opacity:0.3;}',
    '#wwp-clb-prev,#wwp-clb-next{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.14);border:none;color:#fff;font-size:28px;width:40px;height:40px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(4px);transition:background .15s;}',
    '#wwp-clb-prev:hover,#wwp-clb-next:hover{background:rgba(255,255,255,.25);}',
    '#wwp-clb-prev{left:0;} #wwp-clb-next{right:0;}',
    '#wwp-clb-foot{margin-top:16px;display:flex;flex-direction:column;align-items:center;gap:12px;}',
    '#wwp-clb-dots{display:flex;gap:6px;flex-wrap:wrap;justify-content:center;}',
    '.wwp-clb-dot{width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.3);border:none;cursor:pointer;padding:0;transition:all .2s;flex-shrink:0;}',
    '.wwp-clb-dot.is-on{background:#E0948F;width:18px;border-radius:3px;}',
    '#wwp-clb-count{font-size:12px;color:rgba(255,255,255,.5);font-family:Montserrat,sans-serif;letter-spacing:.04em;}',
    '#wwp-clb-cta{display:inline-flex;align-items:center;gap:8px;padding:11px 26px;border-radius:40px;background:#E0948F;color:#2B2926;font-family:Montserrat,sans-serif;font-size:13px;font-weight:700;text-decoration:none;transition:background .15s;}',
    '#wwp-clb-cta:hover{background:#C97970;color:#FFFDFB;}',
    '#wwp-clb-title{font-size:13px;color:rgba(255,255,255,.7);font-family:Montserrat,sans-serif;text-align:center;max-width:80vw;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}'
  ].join('');
  document.head.appendChild(S);

  /* ── Build lightbox DOM ── */
  var lb=document.createElement('div');
  lb.id='wwp-clb';
  lb.setAttribute('role','dialog');
  lb.setAttribute('aria-modal','true');
  lb.setAttribute('aria-label','Product images');
  lb.innerHTML=
    '<button id="wwp-clb-close" aria-label="Close">&times;</button>'+
    '<p id="wwp-clb-title"></p>'+
    '<div id="wwp-clb-wrap">'+
      '<button id="wwp-clb-prev" aria-label="Previous image">&#8249;</button>'+
      '<img id="wwp-clb-img" src="" alt="">'+
      '<button id="wwp-clb-next" aria-label="Next image">&#8250;</button>'+
    '</div>'+
    '<div id="wwp-clb-foot">'+
      '<div id="wwp-clb-dots"></div>'+
      '<p id="wwp-clb-count"></p>'+
      '<a id="wwp-clb-cta" href="#">'+
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'+
        'View full details'+
      '</a>'+
    '</div>';
  document.body.appendChild(lb);

  var lbImg=document.getElementById('wwp-clb-img');
  var lbDots=document.getElementById('wwp-clb-dots');
  var lbCount=document.getElementById('wwp-clb-count');
  var lbCta=document.getElementById('wwp-clb-cta');
  var lbTitle=document.getElementById('wwp-clb-title');
  var lbCur=0,lbAll=[];

  function open(imgs,url,title){
    lbAll=imgs; lbCur=0;
    lbCta.href=url||'#';
    lbTitle.textContent=title||'';
    buildDots();
    draw();
    lb.classList.add('is-open');
    document.body.style.overflow='hidden';
  }
  function draw(){
    var u=lbAll[lbCur];
    if(!u)return;
    if(typeof u==='object')u=u.src||u.url||'';
    if(u.indexOf('//')===0)u='https:'+u;
    lbImg.classList.add('is-loading');
    var tmp=new Image();
    tmp.onload=function(){lbImg.src=tmp.src;lbImg.classList.remove('is-loading');};
    tmp.src=u+(u.indexOf('?')>-1?'&':'?')+'width=900';
    lbCount.textContent=(lbCur+1)+' / '+lbAll.length;
    lbDots.querySelectorAll('.wwp-clb-dot').forEach(function(d,i){d.classList.toggle('is-on',i===lbCur);});
    var single=lbAll.length<2;
    document.getElementById('wwp-clb-prev').style.display=single?'none':'';
    document.getElementById('wwp-clb-next').style.display=single?'none':'';
    lbDots.style.display=single?'none':'';
    lbCount.style.display=single?'none':'';
  }
  function buildDots(){
    lbDots.innerHTML=lbAll.map(function(u,i){
      return'<button class="wwp-clb-dot'+(i===0?' is-on':'')+' " data-i="'+i+'" aria-label="Image '+(i+1)+'"></button>';
    }).join('');
  }
  function go(d){lbCur=(lbCur+d+lbAll.length)%lbAll.length;draw();}
  function close(){lb.classList.remove('is-open');document.body.style.overflow='';}

  document.getElementById('wwp-clb-close').addEventListener('click',close);
  document.getElementById('wwp-clb-prev').addEventListener('click',function(e){e.stopPropagation();go(-1);});
  document.getElementById('wwp-clb-next').addEventListener('click',function(e){e.stopPropagation();go(1);});
  lb.addEventListener('click',function(e){if(e.target===lb)close();});
  lbDots.addEventListener('click',function(e){
    var d=e.target.closest('.wwp-clb-dot');
    if(d){lbCur=parseInt(d.dataset.i,10);draw();}
  });
  document.addEventListener('keydown',function(e){
    if(!lb.classList.contains('is-open'))return;
    if(e.key==='Escape')close();
    if(e.key==='ArrowLeft')go(-1);
    if(e.key==='ArrowRight')go(1);
  });
  /* Swipe */
  var sx=null;
  lb.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
  lb.addEventListener('touchend',function(e){
    if(sx===null)return;
    var dx=e.changedTouches[0].clientX-sx;sx=null;
    if(Math.abs(dx)>40)go(dx<0?1:-1);
  });

  /* ── Fetch product images ── */
  function getImages(handle,cb){
    if(cache[handle]){cb(cache[handle]);return;}
    fetch(root+'products/'+handle+'.js')
      .then(function(r){return r.ok?r.json():null;})
      .then(function(p){
        var imgs=[];
        if(p&&p.images&&p.images.length){
          imgs=p.images;
        }else if(p&&p.media){
          imgs=p.media.filter(function(m){return m.media_type==='image';}).map(function(m){return m.src||m;});
        }
        cache[handle]=imgs;
        cb(imgs);
      })
      .catch(function(){cb([]);});
  }

  /* ── CAPTURE PHASE click handler — fires before Dawn's anchor ── */
  document.addEventListener('click',function(e){
    /* Find if click was on or inside a .wwp-img-btn */
    var btn=e.target.closest('.wwp-img-btn');
    if(!btn)return;
    /* Stop everything — prevent anchor navigation */
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var handle=btn.getAttribute('data-wwp-lb-handle');
    var url=btn.getAttribute('data-wwp-lb-url')||btn.closest('[data-wwp-lb-url]')&&btn.closest('[data-wwp-lb-url]').getAttribute('data-wwp-lb-url');
    var title=btn.getAttribute('data-wwp-lb-title')||'';
    if(!handle)return;
    getImages(handle,function(imgs){
      if(!imgs.length){
        window.location.href=url||'#';
        return;
      }
      open(imgs,url,title);
    });
  /* USE CAPTURE PHASE — true as third arg fires before bubble phase (anchor) */
  },true);

})();
